"use client";

import { Button } from "@/components/ui/button";

import { useActions } from "./use-actions";

export const ListEmpty = () => {
  const { handler } = useActions();

  return (
    <div className="flex flex-col py-10 gap-8">
      <h2 className="text-center">Nenhum leilão encontrado</h2>
      <div className="flex items-center justify-center">
        <Button onClick={handler.cleanSearch}>
          Limpar filtros para ver mais imóveis
        </Button>
      </div>
    </div>
  );
};
